import { render, staticRenderFns } from "./cq_jm.vue?vue&type=template&id=20b3eaa8&"
import script from "./cq_jm.vue?vue&type=script&lang=js&"
export * from "./cq_jm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports